import { render } from "./ExternalSystems.vue?vue&type=template&id=835785f6&scoped=true&ts=true"
import script from "./ExternalSystems.vue?vue&type=script&lang=ts"
export * from "./ExternalSystems.vue?vue&type=script&lang=ts"

import "./ExternalSystems.vue?vue&type=style&index=0&id=835785f6&scoped=true&lang=scss"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-835785f6"]])

export default __exports__